import AccountModel from '../models/AccountModel';

export default class AccountCollection extends Backbone.Collection {
  constructor(options) {
    super(options);
    this.model = AccountModel;
  }

  dispatchCallback(payload) {
    let actionType = payload.actionType;
    let ActionTypes = appConstants.ActionTypes;

    switch (actionType) {
      case ActionTypes.CHECK_TOKEN_EXPIRATION:
        Utils.setMakeshiftTokenHeader();
        AccountStore.fetch({
          url: appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV + 
               appConstants.ApiPaths.API_VERSION_PATH + 
               appConstants.EndPoints.TOKEN_PATH,
          type: 'GET',
          contentType: 'application/json',
          error: AccountStore.onTokenInvalidError,
          success: payload.callback,
        });
        break;

      case ActionTypes.PASSWORD_VALIDITY:
        Utils.setMakeshiftTokenHeader();
        $.ajax({
          type: 'POST',
          data: payload.postData,
          url: appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV + 
               appConstants.ApiPaths.API_VERSION_PATH + 
               appConstants.EndPoints.PASSWORD_VALIDITY,
          dataType: 'json',
        })
          .done(function(data) {
            AccountStore.validatePasswordSuccess();
          })
          .fail(function(data) {
            AccountStore.validatePasswordFailure(data.responseJSON);
          });
        break;

      case ActionTypes.USER_CHANGED:
        let model = AccountStore.get(user.id);
        model.set({ user });
        break;

      case ActionTypes.UPDATE_PASSWORD:
        Utils.setMakeshiftTokenHeader();
        AccountStore.fetch({
          type: 'PUT',
          data: { user: payload.postData },
          url: appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV +
               appConstants.ApiPaths.API_VERSION_PATH + 
               appConstants.EndPoints.UPDATE_USER,
          success: AccountStore.updatePasswordSuccessCallback,
          error: AccountStore.updatePasswordErrorCallback,
        });
        break;

      case ActionTypes.UPDATE_USER:
        Utils.setMakeshiftTokenHeader();
        AccountStore.fetch({
          type: 'PUT',
          data: { user: payload.postData, force_update: true },
          url: appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV +
               appConstants.ApiPaths.API_VERSION_PATH + 
               appConstants.EndPoints.UPDATE_USER,
          success: AccountStore.updateSuccessCallback,
          error: AccountStore.updateErrorCallback,
        });
        break;

      case ActionTypes.CORE_SHOW_USER:
        Utils.setMakeshiftTokenHeader();
        AccountStore.fetch({
          url: appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV + 
               appConstants.ApiPaths.API_VERSION_PATH + 
               appConstants.EndPoints.USER_PROFILE_PATH,
          type: 'GET',
          contentType: 'application/json',
          data: payload.data,
          success: AccountStore.onCoreAccountSuccess,
          fail: AccountStore.onAccountError,
          error: AccountStore.onAccountError
        });
        break;
    }
  }
}
